<template>
    <div ref="resHtmlBox" class="resourcehtml">
        <div ref="resourceTitle" class="resourcehtml-title">{{ resourceHTML.name }}</div>
        <div ref="resourceMain" v-html="resourceHTML.content" class="resourcehtml-main"></div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        }
        
    },

    data: function() {
        return {
            componentId: null,
            resourceHTML: {},
            resourceHTMLId: null,
            supportedEventNames: ['resource.show', 'files.zoom', 'waiting','common.moveJoystick'],
        };
    },

    computed: {
    },

    watch: {
        currentShow: function(newVal, oldVal) {
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.resetStatus();
            }
        }
    },

    created: function() {
    },
    
    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },


    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    methods:{
        newResourceData: function(data){
            this.resourceHTML = data;
            this.resourceHTMLId = data.id;
            Vue.nextTick(() => {
                this.convertMML2SVG();
            });
        },
        zoomTo: function (data) {
            if (data.id === this.resourceHTMLId) {
                let scaleFactorMath = Number(data.scaleFactor).toFixed(2);
                let maxW = window.innerWidth;
                var mainWTomaxW = Number(maxW / 980).toFixed(2);
                // console.log(980 * scaleFactorMath,maxW);
                if (980 * scaleFactorMath >= maxW) {
                    this.$refs.resourceMain.style.transform = 'scale(' + mainWTomaxW + ')' ;
                } else {
                    this.$refs.resourceMain.style.transform = 'scale(' + scaleFactorMath + ')' ;
                }
            }
        },

        moveJoystick: function(msgData) {
            let resHtmlBox = this.$refs.resHtmlBox;
            let direction = msgData.direction;
            if (direction === 'LEFT') return;
            if (direction === 'RIGHT') return;
            if (direction === 'UP') resHtmlBox.scrollTop -= 40;
            if (direction === 'DOWN') resHtmlBox.scrollTop += 40;
            
        },

        resetStatus: function() {
            console.log('the status is being reset');
            this.$refs.resourceMain.style.transform = 'scale(1, 1)';
            this.$refs.resourceMain.style.height =  '';
            this.resourceHTML = {};
            this.resourceHTMLId = null;
        },

        windowMessageHandler: function(e) {
            let msg = e.data;
            if (! msg.eventName || this.supportedEventNames.indexOf(msg.eventName) === -1) return;
            if (this.isLock && this.currentShow === this.componentId) return;
            if (!this.isLock && this.currentShow !== this.componentId) return;
            let resData = msg.data;

            if (this.currentShow !== this.componentId) return;

            if (msg.eventName === 'resource.show') {
                if (! resData.mimeType || resData.mimeType !== 'mosoink/html') return;
                this.newResourceData(resData);
                Vue.nextTick(() => {
                    // console.log(this.$refs.resourceMain.getBoundingClientRect())
                    let resourceMainH = this.$refs.resourceMain.getBoundingClientRect().height;
                    let watchH = window.innerHeight - this.$refs.resourceTitle.getBoundingClientRect().height;
                    if (resourceMainH < watchH) {
                        console.log(resourceMainH,watchH);
                        this.$refs.resourceMain.style.height = window.innerHeight - this.$refs.resourceTitle.getBoundingClientRect().height + 'px';
                    };
                });
            } else if (msg.eventName === 'files.zoom') {
                this.zoomTo(resData);
            } else if (msg.eventName === 'common.moveJoystick') {
                this.moveJoystick(resData);
            } else {
                return;
            }
        },

        /**
         * Convert all of the mathml to svg for browser compatibility
         * @return {void} 
         */
        convertMML2SVG: function() {
            const mmlElements = document.querySelectorAll('math');
            console.log('mathml elements:', mmlElements.length);
            if (mmlElements.length === 0) return;

            // default font size of formula is 24, and default font size of document is 16px. so the formula font size is 1.5 times document font size
            let fontSize = '24px';
            if (document.querySelector('html').style.fontSize != '') {
                fontSize = (parseInt(document.querySelector('html').style.fontSize) * 1.5) + 'px';
            }

            let index = 0;
            const _convert = mmlEle => {
                const baseUrl = 'https://wiris-server.mosoteach.cn:2222/editor/render.svg?mml=';
                mmlEle.setAttribute('mathsize', fontSize);
                mmlEle.setAttribute('style', 'font-family: stix');

                // the formula's color follows its' parent color
                let mathColor = '#ffffff';
                if (mmlEle.parentElement) {
                    mathColor = window.getComputedStyle(mmlEle.parentElement).color;
                    if (mathColor) {
                        const parts = mathColor.match(/^rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)$/);
                        if (parts) {
                            parts.shift();
                            mathColor = '#' + parts.map(s => ('0' + parseInt(s).toString(16)).slice(-2)).join('');
                        }
                    }
                }

                mmlEle.setAttribute('mathcolor', mathColor);
                

                const mml = mmlEle.outerHTML;
                this.$http.get(baseUrl + encodeURIComponent(mml))
                    .then(response => {
                        const svgSource = response.data;
                        const spanElement = document.createElement('SPAN');
                        spanElement.setAttribute('class', 'mml-svg-box');
                        spanElement.innerHTML = svgSource;
                        const parentElement = mmlEle.parentElement;
                        if (parentElement) {
                            parentElement.replaceChild(spanElement, mmlEle);    
                        }
                        
                        index += 1;
                        if (index < mmlElements.length) {
                            _convert(mmlElements[index]);
                        }
                    })
                    .catch(err => {
                        console.log('error occured while convert mml to svg', err);
                        index += 1;
                        if (index < mmlElements.length) {
                            _convert(mmlElements[index]);
                        }
                    });
            };
            const nextElement = mmlElements[index];
            _convert(nextElement);
        },
    }
};
</script>

<style>
    .resourcehtml {
        color: #000000;
        overflow-y: auto;
    }
    
    .resourcehtml-title {
        width: 100%;
        font-size: 24px;
        padding: 20px 0;
        color: #FFFFFF;
    }
    
    .resourcehtml-main {
        width: 980px;
        padding: 40px;
        box-sizing: border-box;
        background: #FFFFFF;
        margin: 0 auto;
        text-align: left;
        transform-origin: top;
        transition: all ease 300ms;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
    }

    .resourcehtml-main > div {
        width: 100%;
        background: #FFFFFF;
    }
    
    .resourcehtml-main img {
        max-width: 100%;
    }

</style>